import { NavLink, Outlet } from "react-router-dom";
import Button from "../../components/ui/Button";
import StrokeTitle from "../../components/ui/StrokeTitle";
import ReactPlayer from "react-player";
import { useState } from "react";
import Modal from "../../components/ui/Modal";
import AltTitle from "../../components/ui/AltTitle";

const CombatSystem = () => {
  return (
    <>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="jumbification">
            <Button text="Mode Mégamax" color="red"/>
          </NavLink>
          <NavLink to="kill-tech">
            <Button text="Attaques spéciales" color="red"/>
          </NavLink>
          <NavLink to="ai-battle">
            <Button text="Combats IA" color="red"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Systèmes de base" color="red"/>
          </NavLink>
          <NavLink to="ranked-battle">
            <Button text="Combats classés" color="red"/>
          </NavLink>
          <NavLink to="hell-mode">
            <Button text="Mode Luciférien" color="red"/>
          </NavLink>
        </div>
      </div>
      <Outlet/>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="jumbification">
            <Button text="Mode Mégamax" color="red"/>
          </NavLink>
          <NavLink to="kill-tech">
            <Button text="Attaques spéciales" color="red"/>
          </NavLink>
          <NavLink to="ai-battle">
            <Button text="Combats IA" color="red"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Systèmes de base" color="red"/>
          </NavLink>
          <NavLink to="ranked-battle">
            <Button text="Combats classés" color="red"/>
          </NavLink>
          <NavLink to="hell-mode">
            <Button text="Mode Luciférien" color="red"/>
          </NavLink>
        </div>
      </div>
    </>
  )
}

const Jumbification = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 8
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="max_ss_0.jpg"/>
      <StrokeTitle text="Mode de combat le plus dynamique de toute la série Disgaea... le Mode Mégamax !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Le plus fou de tous les Tactical-RPG existants du monde... Disgaea !

Apparition d'un nouveau système de combat dans Disgaea 7, nommé le « mode Mégamax », dans lequel les personnages deviennent géants !

Explosez en une seule attaque plusieurs ennemis, ouvrez des coffres gigantesques... c'est parti pour le chaos version BIG !
        </p>
      </div>
        <ReactPlayer
          className='react-player fixed-bottom ss-system'
          url={`${process.env.PUBLIC_URL}/img/ss/max.mp4`}
          width='100%'
          height='100%'
          controls = {false}
          loop
          playing
          volume={0}
          muted
          style={{
            maxWidth: '950px',
            marginBottom: '25px'
          }}
        />
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_01.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_02.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
        </div>
      </div>
      <StrokeTitle text="Éliminez tous vos ennemis, à une échelle ébouriffante !"/>
      <div className="text-wrapper">
          <p className="white-text">
          Les personnages passés en mode Mégamax peuvent effectuer des attaques à n'importe quel endroit de la carte !
Les attaques normales peuvent désormais atteindre un rayon super large, profitez-en pour dégager d'un coup plusieurs ennemis regroupés !
          </p>
          <p className="white-text" style={{marginTop: '25px'}}>
            
              Retournement de situation garanti en transformant <br/> vos personnages en géants !
          </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_03.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_04.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 4,
              }
            )
          }}/>
        </div>
      </div>
      <StrokeTitle text="Prenez le contrôle du champ de bataille grâce à vos Mégaléfices."/>
      <div className="text-wrapper">
        <p className="white-text">
          Chaque personnage possède un « Mégaléfice » propre une fois passé en mode Mégamax, comme par exemple : « Les dégâts infligés augmentent de 20 % », ou bien encore : « Regain de PV de 20 % à la fin du tour » !!
        </p>
        <p className="white-text">
          Les Mégaléfices touchent absolument tous les personnages sur la carte, il est donc important de géantifier les bons pour leur faire utiliser leur Mégaléfice au moment opportun.
        </p>
        <p className="white-text">
          N'hésitez pas à abuser du mode Mégamax et des <br/> Mégaléfices de vos personnages !
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_05.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Comment ?! Avec le Mégaléfice des Prinnies « Explosion de joie », tous les personnages qui se font lancer explosent ?! <br/>
            * Mais ils ne meurent pas pour autant.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_06.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 6,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Regagnez des PC avec le Mégaléfice des Sorcières pour pouvoir utiliser à nouveau des sorts de magie et des Capacités d'armes surpuissantes !
          </h3>
        </div>
      </div>
      <StrokeTitle text="Attention attention, vos ennemis aussi ont accès au mode Mégamax !"/>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_07.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 7,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/max_ss_08.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 8,
              }
            )
          }}/>
        </div>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
          Il est tout à fait possible pour vos ennemis de se transformer eux aussi en géants !
          Vérifiez bien les Mégaléfices qu'ils ont à leur disposition afin d'utiliser les bons contre eux !

          Jusqu'à quatre personnages peuvent se taper dessus en même temps, pour une bataille d'anthologie que vous ne serez pas près d'oublier !
        </p>
      </div>
    </>
  )
}

const KillTech = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 5
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="skill_0.jpg"/>
      <StrokeTitle text="Des Capacités d'arme également à votre disposition !"/>
      <div className="text-wrapper">
        <p className="white-text">
        En utilisant suffisamment longtemps une arme, de quelque catégorie qu'elle soit (épée, pistolet, lance... sept au total), vous débloquerez une Capacité ultra puissante appelée la « Capacité d'arme » !
À vous de l'utiliser correctement pour terrasser tous vos ennemis !

Créez sans modération des personnages avec l'arme de votre choix : des magiciens qui se battent à coups de poing, des guerriers spécialistes du tir, etc !
        </p>
      </div>
      <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_01.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
        </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_02.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_03.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
        </div>
      </div>
      <StrokeTitle text="Des attaques de longue portée !
Visez le point faible de vos ennemis avec des attaques de magie !"/>
      <div className="text-wrapper">
          <p className="white-text">
            En évoluant, certains personnages deviennent capables d'apprendre des sorts de magie !
            Il existe trois catégories de magie : la magie de type [Feu], [Vent] et [Eau].
            Choisissez la bonne pour infliger le plus de dégâts possibles à vos ennemis.

            Plus vous persévérerez dans leur utilisation et plus leur portée deviendra importante !

            Alors n'hésitez pas à utiliser la magie le plus souvent possible ! 

            (Tous les personnages sont capables d'apprendre des sorts en débloquant les bonnes conditions)
          </p>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/skill_04.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 4,
                }
              )
        }}/>
      </div>
      <div className="item">
        <img className="large-ss ss-system " src={`${process.env.PUBLIC_URL}/img/ss/skill_05.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 5,
                }
              )
        }}/>
        <h3 className="item-text white-text">
        Des séquences animées ainsi que de splendides illustrations quand on utilise des sorts de magie ultra puissants ?!
        </h3>
      </div>
    </>
  )
}

const AIBattles = () => {
  
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 6
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="ai_ss_0.jpg"/>
      <StrokeTitle text="Que diriez-vous d'utiliser la fonction d'IA pour profiter encore un peu plus du jeu ?"/>
      <div className="text-wrapper">
        <p className="white-text">
          Il est possible d'utiliser dans cet opus l'Intelligence Maléficielle afin de faciliter et de rendre l'expérience de jeu encore plus trépidante !

          Utilisez pour commencer les réglages IA de base déjà placés sur les personnages histoire de vous habituer, puis tripotez un peu à tout pour devenir un pro des Démonicodes et éduquer des personnages qui ne laisseront plus jamais filer la moindre victoire !
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_01.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 1,
                  }
                )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_02.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_03.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 3,
                  }
                )
          }}/>
          <h3 className="item-text white-text">Il est possible d'enregistrer différentes séquences d'actions et de réactions en utilisant des Démonicodes, qui vous faciliteront la vie une fois réglés.</h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_04.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 4,
                  }
                )
          }}/>
          <h3 className="item-text white-text">Commencez par créer un modèle !</h3>
        </div>
      </div>
      <StrokeTitle text="Comment augmenter de niveau sans trop se prendre la tête ?"/>
        <div className="text-wrapper">
          <p className="white-text">
          Vous pouvez effectuer des « combats automatiques » en utilisant de l'« Infernol » sur un niveau que vous avez terminé au moins une fois.
Il vous suffit ensuite de lancer vos Démonicodes réglés au préalable pour recommencer et terminer le niveau automatiquement.
Le montant d'Infernol nécessaire dépendra du nombre de tours que vous avez utilisé pour terminer le niveau... Ajustez l'IA à ce dernier pour être le plus efficace possible !
          </p>
        </div>
        <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_05.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 5,
                  }
                )
          }}/>
          <h3 className="item-text white-text">Il n'est possible d'effectuer des combats automatiques que sur des niveaux déjà terminés.</h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ai_ss_06.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 6,
                  }
                )
          }}/>
          <h3 className="item-text white-text">Il est possible d'utiliser de l'Infernol pour sauter les combats et simplement récupérer les points d'expérience et les récompenses la fois suivante d'un niveau terminé au moins une fois.</h3>
        </div>
        </div>
        <StrokeTitle text="Terminez tous les niveaux et récupérez de l'Infernol à foison !"/>
        <div className="text-wrapper">
          <p className="white-text">
          Vous pouvez récupérer de l'Infernol (le coût des combats automatiques) en terminant les niveaux présents dans le Monde des Objets.
À vous d'en faire le plus de réserves possibles !

Faites évoluer vos personnages en utilisant aussi de l'Infernol, afin de les rendre encore plus puissants !
          </p>
        </div>
    </>
  )
}

const Basic = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 3
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="basic_0.png"/>
      <StrokeTitle text="Un T-RPG qui sort des sentiers battus !"/>
      <div className="text-wrapper">
        <p className="white-text">
          Un jeu dans lequel absolument tout est possible ! <br/>

          Des combats à grands coups de persos avec des niveaux de 9999 et des milliards de dégâts, des techniques de combat vous permettant de soulever ou de lancer vos alliés ou vos ennemis, bref, que du bon que vous ne trouverez dans aucun autre jeu !
        </p>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/basic_01.png`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 1,
                  }
                )
          }}/>
           <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/basic_02.png`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
          }}/>
      </div>
      <StrokeTitle text="Explosez vos ennemis en effectuant des attaques groupées !"/>
      <div className="text-wrapper">
        <p className="white-text">
          Vous connaissez les attaques groupées ? Ce sont des attaques spéciales dont les dégâts sont amplifiés quand des personnages se situent à vos côtés !
          Avec des animations dédiées à ces attaques en plus !
          Utilisez vos personnages préférés pour les déclencher !
        </p>
      </div>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/basic_03.png`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 3,
                }
              )
        }}/>
        <h3 className="item-text white-text">
          Des animations uniques pour des attaques uniques !
        </h3>
      </div>
      <StrokeTitle text="Soulever et lancer, la base du combat !"/>
      <div className="text-wrapper">
        <p className="white-text">
          Vous pouvez soulever et lancer des alliés ou des ennemis se trouvant à proximité durant un combat. Vous vous rapprochez ainsi plus rapidement d'ennemis hors de portée ou éloignez des ennemis un peu trop proches pour gagner du temps... Deux tactiques très pratiques pour élargir votre panel de stratégies !
        </p>
      </div>
      <ReactPlayer
          className='react-player fixed-bottom ss-system'
          url={`${process.env.PUBLIC_URL}/img/ss/basic.mp4`}
          width='100%'
          height='100%'
          controls = {false}
          loop
          playing
          volume={0}
          muted
        />
    </>
  )
}

const RankedBattles = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 10
  })

  return (
    <>
    <Modal modal={modal} setModal={setModal} url="rank_0.jpg"/>
      <StrokeTitle text="Des combats utilisant l'IA contre des joueurs de tout le pays !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Nouveau système de combat utilisant l'IA, qui va vous permettre de faire affronter vos personnages contre ceux d'autres joueurs de tout le pays.

À vous de régler les bonnes séquences de jeu et de mettre en place les tactiques les plus efficaces suivant les niveaux et vos adversaires pour les battre.

Une bonne tactique au pif peut aussi se révéler être une clef pour des victoires futures !
        </p>
      </div>
      <StrokeTitle text="Voyons voir à quoi ressemblent les règles de base !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Vous allez devoir gagner des points durant vos combats, afin d'améliorer votre classement en ligne.

Plus vous remporterez de combats, plus votre rating augmentera. De la même façon que des défaites vous feront dégringoler dans le classement... Alors à vous de faire les bons choix pour grimper sur le podium !
        </p>
      </div>
      <StrokeTitle text="Réglez l'IA et jetez-vous dans les combats !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Les personnages des combats classés effectuent leurs actions suivant les ordres des Démonicodes réglés au préalable. Utilisez l'IA du jeu afin de leur faire prendre les bonnes décisions suivant le niveau et les règles !

À vous de voir si vous préférez les faire attaquer en priorité ou bien regagner en énergie régulièrement par exemple. Vous pouvez bien sûr profiter des réglages de base pour vous faire la main sur le système !
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_01.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 1,
                }
              )
        }}/>
        <h3 className="item-text white-text">
        Ce sont des combats utilisant l'IA du jeu. Pour pouvoir y participer, commencez par régler des Démonicodes sur vos personnages.
        </h3>
        </div>
        <div className="pair">
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_02.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 2,
                  }
                )
          }}/>
          <h3 className="item-text white-text">
          Rendez-vous dans l'Arène et montez votre équipe. Une fois vos membres décidés, c'est parti pour les réglages de base.
          </h3>
          </div>
          <div className="item">
            <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_03.jpg`} alt="Top-SS" onClick={()=>{
                setModal(
                  {
                    ...modal,
                    'visible': true,
                    'current': 3,
                  }
                )
          }}/>
          <h3 className="item-text white-text">
          Quand tout est OK, chargez votre équipe. C'est bon, vous êtes prêts pour aller vous battre.
          </h3>
          </div>
        </div>
      </div>
      <StrokeTitle text="Prenez bien en compte les diverses affinités existantes entre les équipes !"/>
      <div className="text-wrapper">
        <p className="white-text">
          Vous pouvez choisir votre adversaire parmi trois équipes sélectionnées au hasard, mais au classement proche du vôtre.
          Vérifiez parmi ces équipes leurs formations et leur classement, et choisissez celle contre laquelle vous avez le plus de chances de gagner !
        </p>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_04.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 4,
              }
            )
      }}/>
      <h3 className="item-text white-text">
        Il est possible de vérifier les caractéristiques et les niveaux des équipes adverses avant les combats.
      </h3>
      </div>
      <div className="text-wrapper">
        <StrokeTitle text="Des niveaux variés !"/>
        <p className="white-text">
        Changement de carte à chaque partie.
Certaines cartes sont basées sur l'utilisation de géocases, d'autres sur la différence de hauteur des objets qui la parsèment... bref, jamais deux cartes identiques.
À vous de faire les bons choix suivant ce qui vous tombe dessus.
        </p>
        <div className="pair">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_05.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_06.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 6,
              }
            )
          }}/>
        </div>
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_07.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 7,
              }
            )
          }}/>
        <StrokeTitle text="Non seulement les cartes changent, mais les règles aussi !"/>
        <p className="white-text">
          Vous allez devoir composer avec des règles particulières à chaque partie, du genre « Seulement les démons sont autorisés » !
          L'occasion parfaite pour créer une foultitude de personnages qui répondront à tous les critères de jeu éventuels !
        </p>
      </div>

      <StrokeTitle text="Deux modes pour vous entraîner en combats classés !"/>
      <AltTitle text="Mode Combat Test - Pour analyser dans les détails les tactiques qui fonctionnent contre un adversaire"/>
      <div className="text-wrapper">
        <p className="white-text">
        Mode dans lequel vous allez pouvoir affronter une équipe dont l'IA est déjà réglée. Vous pourrez en même temps régler vos Démonicodes pour vous préparer à affronter tous types d'ennemis !
        </p>
      </div>
      <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_08.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 8,
              }
            )
          }}/>
      <AltTitle text="Mode Combat libre - Pour essayer vos Démonicodes sur le terrain..."/>
      <div className="text-wrapper">
        <p className="white-text">
          Mode de combat dans lequel le résultat des matchs n'influe pas votre rating. Vous allez pouvoir essayer tout un tas d'options et de tactiques sans risque, c'est pas beau ça ?
          Avec ce mode, les combats classés ne seront plus qu'un jeu d'enfant !
        </p>
      </div>
      <div className="pair">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_09.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 9,
              }
            )
          }}/>
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rank_010.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 10,
              }
            )
          }}/>
      </div>
    </>
  )
}

const Hell = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 2
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="revenge_ss_0.png"/>
      <StrokeTitle text="La puissance légendaire du Mode Luciférien à votre portée !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Certains personnages remplissent une « Jauge Luciférienne » en se battant.
Une fois cette dernière remplie au max, elle vous donne accès au « mode Luciférien ».
En l'activant, toutes les statistiques du personnage explosent et il devient capable d'utiliser des Capacités spéciales particulières !
Éradiquez de Hinomoto tous les vilains méchants en utilisant la force légendaire conférée par ce mode !
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/revenge_ss_01.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
          <h3 className="white-text item-text">
          Les conditions d'activation du mode Luciférien diffèrent suivant chaque personnage.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/revenge_ss_02.png`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
          <h3 className="white-text item-text">
          Les Capacités que permettent d'effectuer ce mode sont ultra puissantes.
        </h3>
        </div>
      </div>
      <StrokeTitle text="Les Sept Armes fondatrices et leurs possesseurs"/>
      <div className="text-wrapper"
          style={{
            paddingBottom: '50px'
          }}
      >
        <AltTitle text="L'épée démoniaque Kanzan Musashi"/>
        <p className="white-text"
          style={{
            paddingBottom: '50px'
          }}
        >
        Épée de Fuji. Elle est capable de trancher n'importe quelle matière existante.

Elle fait diminuer la puissance de défense de celui qu'elle attaque et lui inflige d'importants dégâts.
        </p>
        <ReactPlayer
              className='react-player fixed-bottom ss-system'
              url={`${process.env.PUBLIC_URL}/img/ss/revenge1.mp4`}
              width='100%'
              height='100%'
              controls = {false}
              loop
              playing
              volume={0}
              muted
            />
      </div>
      <div className="text-wrapper"
                  style={{
            paddingBottom: '50px'
          }}
      >
        <AltTitle text="Le sceptre démoniaque Tokugawa Tenge"/>
        <p className="white-text"
                    style={{
            paddingBottom: '50px'
          }}
        >
        Sceptre utilisé par Oyéyasu. Il oblige à exécuter n'importe quel ordre proféré par son possesseur.

Il inflige l'altération d'état [Manipulation] aux ennemis proches de lui lorsqu'il rentre en mode Luciférien.
        </p>

        <ReactPlayer
          className='react-player fixed-bottom ss-system'
          url={`${process.env.PUBLIC_URL}/img/ss/revenge2.mp4`}
          width='100%'
          height='100%'
          controls = {false}
          loop
          playing
          volume={0}
          muted
        />

      </div>
    </>
  )
}

export default CombatSystem;
export {
  Jumbification, KillTech, AIBattles, Basic, RankedBattles, Hell
};